// [APP 1 - routes]
import routesApp from './8apps/routes.js';
routesApp.mount('#app');
